@if (showLoading) {
  <div class="loading-container">
    <div class="loading-spinner">
      <img src="/assets/icon.png" alt="Loading application" title="Loading..." width="30" height="30" loading="eager" />
    </div>
  </div>
} @else {
  <div class="fade-in" id="mymain">
    <router-outlet></router-outlet>
  </div>
  <app-lock-screen></app-lock-screen>
  @if (routeHasHome) {
    <div class="beta-label">Beta I Release</div>
  }
  <app-google-sign-in></app-google-sign-in>
}
